import { escapeCsvCell } from 'src/admin/LAB/PoolManagement/csvEscape';
import type { Pool } from 'src/admin/models/PoolListModel';

export interface PoolListCsvColumnLabels {
    id: string;
    name: string;
    description: string;
    firm: string;
    status: string;
    permission: string;
}

export interface CreatePoolListCsvOptions {
    /**
     * Human labels for the header row. Pulled out as a parameter (rather
     * than hard-coded English) so the caller can localize via i18n
     * without re-importing this module.
     */
    columnLabels: PoolListCsvColumnLabels;
    /** Resolves a firm id to its display name; the raw id is exported when unresolved. */
    firmNamesByFirmId: Readonly<Record<string, string>> | null;
}

/**
 * Serialize the pool list to a CSV string. Pure: no clock reads, no DOM
 * access, no i18n imports, mirroring `createChangeLogCsv`.
 */
export function createPoolListCsv(pools: ReadonlyArray<Pool>, options: CreatePoolListCsvOptions): string {
    const { columnLabels, firmNamesByFirmId } = options;
    const header = [
        escapeCsvCell(columnLabels.id),
        escapeCsvCell(columnLabels.name),
        escapeCsvCell(columnLabels.description),
        escapeCsvCell(columnLabels.firm),
        escapeCsvCell(columnLabels.status),
        escapeCsvCell(columnLabels.permission),
    ].join(',');
    const lines = [header];
    for (const pool of pools) {
        lines.push(
            [
                escapeCsvCell(pool.id),
                escapeCsvCell(pool.name),
                escapeCsvCell(pool.description ?? ''),
                escapeCsvCell(firmNamesByFirmId?.[pool.firmId] ?? pool.firmId),
                escapeCsvCell(pool.status),
                escapeCsvCell(pool.permission),
            ].join(','),
        );
    }
    return lines.join('\n') + '\n';
}
